import * as _ from 'lodash';
import useCubeReportQuery from './useCubeReportQuery';

function useTopFiveMerchantByAcceptRejectReview(
    chartType: Top5MerchantChartType,
    focusView: AcceptRejectReview,
    formValues?: ProcessedNewMerchantReportFormValues
) {
    const capitalizedChartType = _.capitalize(chartType);
    const query = formValues?.fullQueries?.[`top5${capitalizedChartType}`][focusView];
    const { resultSet, isLoading } = useCubeReportQuery(formValues, query);
    const pivotData = resultSet?.tablePivot();
    let processedData: Top5ValueVolumeTableItem[] = [];
    if (pivotData && pivotData.length > 0) {
        const topPercentage = Number(pivotData[0][`MerchantSummary.total${capitalizedChartType}Percent${focusView}`]);
        processedData = pivotData.map((pData: Record<string, any>) => ({
            merchantId: pData['MerchantSummary.mid'],
            [chartType]: Number(pData[`MerchantSummary.${chartType}${focusView}Transactions`]),
            [`percentScaled${focusView}`]:
                topPercentage !== 0
                    ? (Number(pData[`MerchantSummary.total${capitalizedChartType}Percent${focusView}`]) * 100) /
                      topPercentage
                    : 0,
            [`percent${focusView}`]: pData[`MerchantSummary.total${capitalizedChartType}Percent${focusView}`] || 0
        }));
    }

    return {
        isLoading,
        processedData
    };
}

export default useTopFiveMerchantByAcceptRejectReview;
